import { Link, useLocation } from "wouter";

const NEAREST = [
  { href: "/app/dashboard", label: "Dashboard" },
  { href: "/app/orders", label: "Orders" },
  { href: "/app/reports", label: "Reports" },
  { href: "/app/suppliers", label: "Suppliers" },
  { href: "/app/outlets", label: "Outlets" },
];

export function NotFound404() {
  const [loc] = useLocation();
  const wanted = loc.replace(/^\/app\//, "");
  return (
    <div className="max-w-xl mx-auto py-16 text-center space-y-5">
      <p className="text-xs uppercase tracking-wider text-ink-mute">404</p>
      <h1 className="font-display text-3xl text-ink">
        Page not found in your portfolio
      </h1>
      <p className="text-ink-2">
        Nothing's wired to <code className="px-1.5 py-0.5 rounded bg-canvas-2 border border-line text-sm">/app/{wanted}</code> yet. Your real data lives on the routes below.
      </p>
      <div className="flex flex-wrap justify-center gap-2 pt-2">
        {NEAREST.map((n) => (
          <Link
            key={n.href}
            href={n.href}
            className="inline-flex items-center gap-1.5 rounded-md border border-line bg-canvas-2 px-3 py-1.5 text-sm hover:bg-mint hover:border-nomni-green/40 transition"
          >
            {n.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
